// extracted by mini-css-extract-plugin
export default {"apresentacao":"section3_apresentacao__aOuSm","apresentacao__Conteudo":"section3_apresentacao__Conteudo__lFXqm"};